<template>
  <div class="portlet light">
    <div class="portlet-title">
      <div class="caption">
          <i class="icon-microphone font-dark hide"></i>
          <span class="caption-subject bold font-dark uppercase">Panneau D'administration</span>
      </div>
    </div>
    <div class="portlet-content">
      <p>Bienvenue sur le panneau d'administration</p>
      <bureaux :bureaux='bureaux'></bureaux>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      bureaux:Object
    }
  },
  mounted:function(){
      var self = this
      axios.get('api/get/bureaux').then(function(response){console.log(response.data);self.bureaux = response.data})
  }
  }
</script>

<style lang="css">
</style>
